


















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Month from "./month.vue";
import Pagination from "./datePagination.vue";
import PreselectedRanges from "./preselectedRanges.vue";
import { weeksInThisMonth } from "./utils";

@Component({
  components: {
    month: Month,
    pagination: Pagination,
    "preselected-ranges": PreselectedRanges
  }
})
export default class DateRangePicker extends Vue {
  @Prop({ default: () => [] })
  public value!: Date[];

  @Prop({ required: true })
  public preselectOptions!: any[];

  public range: Date[] = [];

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public time!: boolean;

  public visibleMonths = 3;

  public selectedBeginDate: Date | null =
    this.value && this.value.length > 0 ? this.value[0] : null;
  public selectedEndDate: Date | null =
    this.value && this.value.length > 1 ? this.value[1] : null;
  public hoveredEndDate: Date | null = null;

  public created() {
    this.initDates({ value: this.value });
    this.setRange();
  }

  public weeksInThisMonth(date) {
    return weeksInThisMonth(date);
  }

  public setRange() {
    const year = this.selectedBeginDate
      ? this.selectedBeginDate.getFullYear()
      : new Date().getFullYear();
    const month = this.selectedBeginDate
      ? this.selectedBeginDate.getMonth()
      : new Date().getMonth();
    const first = new Date(year, month, 1);

    const lYear = this.selectedEndDate
      ? this.selectedEndDate.getFullYear()
      : new Date().getFullYear();
    const lMonth = this.selectedEndDate
      ? this.selectedEndDate.getMonth()
      : new Date().getMonth();
    const last = new Date(lYear, lMonth, 1);

    this.range = this.$_.orderBy([
      first,
      this.$moment(last).isSame(first, "month")
        ? this.$moment(first)
            .add(1, "month")
            .toDate()
        : last
    ]);
  }

  /**
   * Prevent showing same date on two months
   */
  public updateRange({ date, index, insert = false }) {
    const mDate = this.$moment(date);

    const endOfMonth = mDate.clone().endOf("month");
    const startOfMonth = mDate.clone().startOf("month");

    const prev = this.$_.get(this, `range[${index - 1}]`, null);
    if (prev && this.$_.isDate(prev)) {
      if (
        this.$moment(prev)
          .endOf("month")
          .isSameOrAfter(startOfMonth, "day")
      ) {
        this.updateRange({
          date: this.$moment(mDate)
            .add(-1, "month")
            .toDate(),
          index: index - 1
        });
      }
    }

    const next = this.$_.get(this, `range[${index + 1}]`, null);
    if (next && this.$_.isDate(next)) {
      if (
        this.$moment(next)
          .startOf("month")
          .isSameOrBefore(endOfMonth, "day")
      ) {
        this.updateRange({
          date: this.$moment(mDate)
            .add(+1, "month")
            .toDate(),
          index: index + 1
        });
      }
    }

    this.range.splice(index, insert ? 0 : 1, date);
  }

  public updateSelection(dates) {
    this.onSelectionChange(dates);
    this.$emit("input", [this.selectedBeginDate, this.selectedEndDate]);
    this.setRange();
  }

  @Watch("value")
  public onSelectionChange(newValue: any) {
    const rangeMin = Math.min(...this.range.map(d => d.getTime()));
    const rangeMax = this.$moment(Math.max(...this.range.map(d => d.getTime())))
      .endOf("month")
      .toDate()
      .getTime();
    const valueMin = Math.min(...newValue);
    const valueMax = Math.max(...newValue);
    const overlap = Math.max(rangeMin, valueMin) < Math.min(rangeMax, valueMax);
    this.initDates({ value: newValue, updateFocusedDate: !overlap });
  }

  public initDates({ value, updateFocusedDate = true }) {
    this.selectedBeginDate = value && value.length > 0 ? value[0] : null;
    this.selectedEndDate = value && value.length > 1 ? value[1] : null;
    this.hoveredEndDate = null;
    if (updateFocusedDate) {
      this.setRange();
    }
  }

  /*
   * If both begin and end dates are set, reset the end date and set the begin date.
   * If only begin date is selected, emit an array of the begin date and the new date.
   * If not set, only set the begin date.
   */
  public handleSelect(date) {
    if (this.selectedBeginDate && this.selectedEndDate) {
      this.selectedBeginDate = this.$moment(date)
        .startOf("day")
        .toDate();
      this.selectedEndDate = null;
    } else if (this.selectedBeginDate && !this.selectedEndDate) {
      if (this.selectedBeginDate > date) {
        this.selectedEndDate = this.$moment(this.selectedBeginDate)
          .startOf("day")
          .toDate();
        this.selectedBeginDate = this.$moment(date)
          .endOf("day")
          .toDate();
      } else {
        this.selectedEndDate = this.$moment(date)
          .endOf("day")
          .toDate();
        this.hoveredEndDate = null;
      }
      this.$emit("input", [this.selectedBeginDate, this.selectedEndDate]);
    } else {
      this.selectedBeginDate = this.$moment(this.selectedBeginDate)
        .startOf("day")
        .toDate();
    }
  }
}
